import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { DisplayElementModel } from './display-element.model';

export class ColorPickerFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent> | null;
    property: string;
    key: string;
    label: string;
    description: string;
    dialogHeading: string;
    icon: string;
    initialValue?: string;
    doBorder: boolean;
    inline: boolean;
    appearCondition: (displayElement: DisplayElementModel) => boolean;


    constructor(
        fieldComponent: Type<AbstractFormFieldComponent> | null,
        property: string,
        key: string,
        label: string,
        description: string,
        dialogHeading: string,
        icon?: string,
        initialValue?: string,
        doBorder: boolean = false,
        inline: boolean = false,
        appearCondition?: (displayElement: DisplayElementModel) => boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.key = key;
        this.label = label;
        this.description = description;
        this.dialogHeading = dialogHeading;
        this.icon = icon;
        this.initialValue = initialValue;
        this.doBorder = doBorder;
        this.inline = inline;
        this.appearCondition = appearCondition;
    }
}
